import { Component, Input, OnInit } from '@angular/core';
import { AdminService, AuthService, CalendarService, ConditionService, DialogService, FieldService, FormulaService, MessagingService, MetadataService, ModalService, SessionService, TranslatorService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UscStoreVisitDataTableAdapter } from '../usc-store-visit-dt-adapter';

@Component({
    selector: 'sn-usc-svt-appointments',
    templateUrl: './usc-svt-appointments.component.html',
    styleUrls: ['./usc-svt-appointments.component.css']
})
export class UscSvtAppointmentsComponent implements OnInit {

    view:string;
    adapter: UscStoreVisitDataTableAdapter;
    public current_store:any;

    constructor(
        public conditionService: ConditionService,
        public translatorService: TranslatorService,
        public fieldService: FieldService,
        public metadataService: MetadataService,
        public formulaService: FormulaService,
        public uscStoreService: UscStoreService,
        public authService: AuthService,
        public calendarService: CalendarService,
        public ngbModal: NgbModal,
        public modalService: ModalService,
        public dialogService: DialogService,
        public sessionService: SessionService,
        public messagingService: MessagingService,
        public adminService: AdminService,
    ) { 
    }

    ngOnInit() {
        var user = this.authService.getActive();
        this.adapter = new UscStoreVisitDataTableAdapter(this.view, {
            'uscStoreService': this.uscStoreService,
            'conditionService': this.conditionService,
            'translatorService': this.translatorService,
            'fieldService': this.fieldService,
            'metadataService': this.metadataService,
            'formulaService': this.formulaService,
            'authService': this.authService,
            'calendarService': this.calendarService,
            'ngbModal': this.ngbModal,
            'modalService': this.modalService,
            'dialogService': this.dialogService,
            'sessionService': this.sessionService,
            'messagingService': this.messagingService,
            'adminService': this.adminService,
        }, user.team_ID);

        this.adapter.root_css_class = 'svt appts';
        this.adapter.initialize();

        if (this.uscStoreService.isLeader()) {
            this.current_store = this.uscStoreService.getSvtStoreUserByScope();
            this.uscStoreService.svtCurrentStore.subscribe(s => {
                this.current_store = s;
            })
        }
    }

    showStoreInfo() {
        return this.uscStoreService.enabledStoreVisitLeaderView();
    }
    
    getStoreName() {
        return this.current_store != null ? this.current_store.store : "";
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-svt-appointments/usc-svt-appointments.component.ts